// ============================================================
// chamber - what the trigger will do.
//
// The attack button is a CHAMBERED trigger (v8.232.0): normally it
// holds the plain attack; selecting a zone on the targeting console
// chambers a called shot at that zone; picking a decisive action in
// the drum chambers that action. This module is the one place that
// ranks those claims, so the button never lies about what firing it
// does. Priority: explicit chamber > console called shot > ATTACK.
// ============================================================

export interface TriggerState {
  /** Name of the drum-chambered action, if any (e.g. 'Feint'). */
  chamberedName?: string | null;
  /** attackToggles.calledShot - the penalty is armed. */
  calledShot: boolean;
  /** Resolved name of the selected zone, if one is selected. */
  locationName?: string | null;
}

/** The trigger's face, uppercased for the stencil. No '(Space)' - the button adds its own hotkey hint. */
export function triggerLabel(state: TriggerState): string {
  if (state.chamberedName) return state.chamberedName.toUpperCase();
  if (state.calledShot && state.locationName) return `CALLED SHOT - ${state.locationName.toUpperCase()}`;
  if (state.calledShot) return 'CALLED SHOT';
  return 'ATTACK';
}
